export default __webpack_public_path__ + "static/media/bridal.481a476a.jpg";